export const Logo = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-label="Edilkrea Technoimpianti" role="img">
    <rect x="5" y="5" width="9" height="38" fill="#D4A373" />
    <rect x="5" y="5" width="34" height="8" fill="#D4A373" />
    <rect x="5" y="21" width="26" height="7" fill="#E07A5F" />
    <rect x="5" y="35" width="34" height="8" fill="#D4A373" />
    <circle cx="39" cy="24.5" r="4" stroke="#E07A5F" strokeWidth="2" />
    <circle cx="39" cy="24.5" r="1.4" fill="#E07A5F" />
  </svg>
);
